import * as svg from "../../../assets/stripe-icon-circle.svg";

import {iconBuilder} from "./iconBuilder";

export const StripeCircleIcon = iconBuilder(svg, "StripeCircleIcon", "0 0 16 16");
